<div class="content-wrapper" *ngIf="!hasUserApprovedContract">
    <div class="row">
      <div class="col-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title"> Approve Manpower Request</h4>
            <h5> Requesters Details</h5>
            <br>
            <form class="forms-sample" #ngNewManPowerForm="ngForm" name="form"
             >    
           
               <div style="background: #ECECEC;padding:30px;">
                <div class="row">
                  <div class="col">
                    <div class="form-group" style="background: white;padding:5px">
                      <label for="description">Requester Name</label>
                      <p>{{ contract?.requesterName  }}</p>
      
                    </div>
                  </div>
      
                  <!-- Designation -->
                  <div class="col">
                    <div class="form-group" style="background: white;padding:5px">
                      <label for="exampleInputCity1">Designation</label>
                      <p>{{ contract?.requesterDesignation  }}</p>
                    </div>
                  </div>
  
                    <!-- Function  -->
                    <div class="col">
                      <div class="form-group" style="background: white;padding:5px">
                        <label for="selectedfunction">Function</label>
                        <p>{{ contract?.requesterFunction  }}</p>
                        
                      </div>
                    </div>
              </div>
                  <div class="row">
                 
    
                  <!-- Unit  -->
                  <div class="col">
                    <div class="form-group" style="background: white;padding:5px">
                      <label for="selectedfunction">Unit</label>
                   
                      <p>{{ contract?.requesterUnit  }}</p>
                    </div>
                  </div>
                 <!-- Request Date  -->
                  <div class="col">
                    <div class="form-group" style="background: white;padding:5px">
                      <label for="exampleInputCity1">Request Date</label>
                      <p>{{ contract?.requestDate  }}</p>
                   
                    </div>
                  </div>
                   
                 
                </div>
              </div>
             
              <br>
  
  
              <h5>Details Of Required Manpower</h5>
              <br>
             
  
  
           <div style="background: #ECECEC;padding:30px;">
            <div class="row">
  
              <!-- Job Title -->
     
              <div class="col">
                <div class="form-group" style="background: white;padding:5px">
                  <label for="description">Job Title</label>
                  <p>{{ contract?.jobTitle  }}</p>
                  
                </div>
              </div>
  
              <!-- N+1 Designation  -->
              <div class="col">
                <div class="form-group" style="background: white;padding:5px">
                  <label for="description">N + 1 Designation</label>
                  <p>{{ contract?.nPlus1Designation  }}</p>
                  
  
                </div>
              </div>
  
                <!-- Band  -->
                <!-- <div class="col">
                  <div class="form-group">
                    <label for="description">Band</label>
                    <input type="text" class="form-control" id="Band"  [(ngModel)]="Band"
                      placeholder="Band" name="Band"  #band="ngModel"  required
                      >
                      <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && band.errors">
                      Band is required!
                    </div>
                  </div>
                </div> -->
                <div class="col">
                  <div class="form-group" style="background: white;padding:5px">
                    <label for="costCenter">Band</label>
                    <p>{{ contract?.band  }}</p>
                  </div>
                </div>
  
                 
            </div>
            <div class="row">
              <!-- Cost Center  -->
   <div class="col">
       <div class="form-group" style="background: white;padding:5px">
         <label for="costCenter">Cost Center</label>
         <p>{{ contract?.band  }}</p>
       </div>
     </div>
  
      <!-- Location  -->
      <div class="col">
          <div class="form-group" style="background: white;padding:5px">
            <label for="selectedLocation">Location</label>
            <p>{{ contract?.location  }}</p>
          </div>
        </div>
         </div>
  
         <div class="row">
            <!-- Date Vacancy Occured  -->
            <div class="col">
              <div class="form-group" style="background: white;padding:5px">
                <label for="exampleInputCity1">Date Vacancy Occured</label>
                <p>{{ contract?.dateVacancyOccurred  }}</p>
                
              </div>
            </div>
  
              <!-- Required Number  -->
              <div class="col">
                  <div class="form-group" style="background: white;padding:5px">
                    <label for="description">Required Number</label>
                    <p>{{ contract?.requiredNumber  }}</p>
                  </div>
                </div>
         </div>
         <br>
         
         <div class="row">
          <div class="col">
            <div class="form-group" style="background: white;padding:5px">
              <label for="TypeOfVacancy">Type Of Vacancy</label>
              <p>{{ contract?.typeOfVacancy  }}</p>
            </div>
          </div>
       
         <div class="col">
          <div class="form-group" style="background: white;padding:5px">
            <label for="costCenter">Reason For Vacancy</label>
            <p>{{ contract?.reasonForVacancy  }}</p>
          </div>
        </div>
      </div>
         <!-- <div class="row">
  
          <label class="col-sm-0 col-form-label"> FTE </label>
          <div class="col-sm-1">
              <div class="form-check">
                <label class="form-check-inline"> 
                     <input type="radio" class="form-check-input" [(ngModel)]="typeOfVacancy" value="FTE" name="typeofvacancy" id="fte">
                </label>
              </div>   
            </div>
  
            <label class="col-sm-0 col-form-label"> FTC: </label>
            <div class="col-sm-1">
                <div class="form-check">
                  <label class="form-check-inline"> 
                       <input type="radio" class="form-check-input" [(ngModel)]="typeOfVacancy" value="FTC" name="typeofvacancy" id="ftc">
                  </label>
                </div>   
              </div>
  
              <label class="col-sm-0 col-form-label"> Consultant: </label>
              <div class="col-sm-1">
                  <div class="form-check">
                    <label class="form-check-inline"> 
                         <input type="radio" class="form-check-input" [(ngModel)]="typeOfVacancy" value="Consultant" name="typeofvacancy" id="consultant">
                    </label>
                  </div>   
                </div>
  
                <label class="col-sm-0 col-form-label"> Internship: </label>
                <div class="col-sm-1">
                    <div class="form-check">
                      <label class="form-check-inline"> 
                           <input type="radio" class="form-check-input" [(ngModel)]="typeOfVacancy" value="Internship" name="typeofvacancy" id="internship">
                      </label>
                    </div>   
                  </div>
            </div> -->
            <br>
            
            <!-- <label> Reason For Vacancy:</label>
            <div class="row">
             <label class="col-sm-0 col-form-label"> Resignation </label>
             <div class="col-sm-1">
                 <div class="form-check">
                   <label class="form-check-inline"> 
                        <input type="radio" class="form-check-input" [(ngModel)]="reasonForVacancy" value="Resignation" name="reasonforvacancy" id="resignation">
                   </label>
                 </div>   
               </div>
  
               <label class="col-sm-0 col-form-label"> Termination: </label>
               <div class="col-sm-1">
                   <div class="form-check">
                     <label class="form-check-inline"> 
                          <input type="radio" class="form-check-input" [(ngModel)]="reasonForVacancy" value="Termination" name="reasonforvacancy" id="termination">
                     </label>
                   </div>   
                 </div>
  
                 <label class="col-sm-0 col-form-label"> Dismissal: </label>
                 <div class="col-sm-1">
                     <div class="form-check">
                       <label class="form-check-inline"> 
                            <input type="radio" class="form-check-input" [(ngModel)]="reasonForVacancy" value="Dismissal" name="reasonforvacancy" id="dismissal">
                       </label>
                     </div>   
                   </div>
  
                   <label class="col-sm-0 col-form-label"> Retirement: </label>
                   <div class="col-sm-1">
                       <div class="form-check">
                         <label class="form-check-inline"> 
                              <input type="radio" class="form-check-input" [(ngModel)]="reasonForVacancy" value="Retirement" name="reasonforvacancy" id="retirement">
                         </label>
                       </div>   
                     </div>
  
                     <label class="col-sm-0 col-form-label"> New Position: </label>
                     <div class="col-sm-1">
                         <div class="form-check">
                           <label class="form-check-inline"> 
                                <input type="radio" class="form-check-input" [(ngModel)]="reasonForVacancy" value="New Position" name="reasonforvacancy" id="newposition">
                           </label>
                         </div>   
                       </div>
               </div>
         -->
  
         <div class="row">
            <!-- Other Specify  -->
            <div class="col">
              <div class="form-group" style="background: white;padding:5px">
                <label for="description">OTHER (Specify)</label>
                <p>{{ contract?.reasonForVacancy  }}</p>
              </div>
            </div>
           
  
          </div>
          <div class="row">
            <!-- <div class="col">
              <div class="form-group">
                <label for="document" class="control-label col-md-10">Select Document (Job Description)</label>
                <div class="col-md-10">
                  <input type="file" (change)="onFileChange($event)" placeholder="Upload file" [(ngModel)]="file"
                    accept=".pdf,.doc" #fileInput name="fileInput" style="padding-top:2px;"
                    class="form-control">
                </div>
              </div>
            </div> -->
  
            <!-- <div class="col">
              <div class="form-group">
                <label for="exampleInputCity1">Document Description</label>
                <input type="text" class="form-control" id="docdescription" placeholder="ex: describe the document" [(ngModel)]="documentDescription"
                name="docdescription" required>
              
              </div>
            </div> -->
          </div>
    
         </div>
           <br>
           <h5> Mode Of Recruitment</h5>
           <br>
            
            <div style="background: #ECECEC;padding:30px;">
              <div class="row">
               
  
                <div class="col">
                  <div class="form-group" style="background: white;padding:5px">
                    <label for="exampleSelectDesignation">Mode Of Recruitment</label>
                    <p>{{ contract?.modeOfRecruitment  }}</p>
                  </div>
                </div>
                <!-- <label class="col-sm-1 col-form-label"> FTE </label> -->
                <!-- <div class="col-sm-1">
                    <div class="form-check">
                      <label class="form-check-inline"> 
                           <input type="radio" class="form-check-input"  [(ngModel)]="modeOfRecruitment" value="FTE" name="modeofrecruitment" id="fte">
                      </label>
                    </div>   
                  </div> -->
    
                  </div>
                     
                 
                    <!-- <label class="col-sm-1 col-form-label"> FTC </label>
                    <div class="col-sm-1">
                        <div class="form-check">
                          <label class="form-check-inline"> 
                               <input type="radio" class="form-check-input"  [(ngModel)]="modeOfRecruitment" value="FTC" name="modeofrecruitment" id="ftc">
                          </label>
                        </div>   
                      </div> -->
    
                        <!-- Duration of contract  -->
                        <!-- <div class="col">
                          <div class="form-group">
                            <label for="description">Contract Duration (Month)</label>
                            <input type="number" class="form-control" id="durationofcontract"
                              placeholder="Duration Of Contract"  name="durationofcontract" [(ngModel)]="ftcdurationofcontract"
                              >
                          </div>
                        </div>
    
                         Estimated Annual Cost  
                      <div class="col">
                        <div class="form-group">
                          <label for="description">Estimated Annual Cost</label>
                          <input type="number" class="form-control" id="estimatedcost"
                            placeholder="Estimated Annual Cost " name="estimatedcost" [(ngModel)]="ftcestimatedcost"
                            >
                        </div>
                      </div> -->
                
                    <!-- <label class="col-sm-0 col-form-label"> Consultant: </label>
                    <div class="col-sm-1">
                        <div class="form-check">
                          <label class="form-check-inline"> 
                               <input type="radio" class="form-check-input" value="Consultant"  [(ngModel)]="modeOfRecruitment" name="modeofrecruitment" id="consultant">
                          </label>
                        </div>   
                      </div>
     -->
                        <!-- Duration of contract  -->
                        <div class="row"   >
                        <div class="col">
                          <div class="form-group" style="background: white;padding:5px">   
                            <label for="description">Contract Duration (Month)</label>
                            <p>{{ contract?.durationOfContract  }}</p>
                          </div>
                        </div>
    
                          <!-- Estimated Annual Cost  -->
                      <div class="col">
                        <div class="form-group" style="background: white;padding:5px">
                          <label for="description">Estimated Annual Cost</label>
                       
                          <p>{{ contract?.estimatedAnnualCost  }}</p>
                        </div>
                      </div>
                  </div>
    
                
                  </div>
                  <div class="col">
                    <div class="form-group" style="background: white;padding:5px">
                      <label for="exampleTextarea1">Justification For Vacancy</label>
                      <textarea class="form-control" id="justification" rows="4" name="justification" [(ngModel)]="justification" #Justification="ngModel"
                        required readonly></textarea>
                      
                      </div>
                 
                  </div>
                  <div class="row">
    
                  </div>
            
      
  
              <br>
             
              <h5>Role Requirements</h5>
              <br>
  
  
              <div style="background: #ECECEC;padding:30px;">
                <div class="row">
               
    
                  <!-- Educational Qualification  -->
                  <div class="col">
                    <div class="form-group" style="background: white;padding:5px">
                      <label for="justification">Educational Qualification</label>
                      <textarea class="form-control" id="educationalqualification" rows="4" name="educationalqualification" required [(ngModel)]="educationalqualification" #educationqualification="ngModel"  readonly>
                        </textarea>
      
                        
                    </div>
                  </div>
      
                  <!-- Skills Required  -->
                  <div class="col">
                    <div class="form-group" style="background: white;padding:5px">
                      <label for="justification">Skills Required</label>
                      <textarea class="form-control" id="skillsrequired" rows="4" #skills="ngModel" name="skillsrequired" [(ngModel)]="skillsrequired" readonly
                       readonly ></textarea>
                     
                  


                    </div>
                  </div>
  
                   <!-- Experience  -->
                   <div class="col">
                    <div class="form-group" style="background: white;padding:5px">
                      <label for="exampleTextarea1">Experience</label>
                      <textarea class="form-control" id="experience" rows="4" name="experience" [(ngModel)]="experience" #Experience="ngModel" readonly
                        required></textarea>
                   
                    </div>
                  </div>
                </div>
  
               
            
      
  
                <label> Systems Requirements</label>
                      <div class="row">

                        <p>{{ contract?.systemRequired  }}</p>

                        
   
  
                           
                               
  
                      </div>
                   
                      <div class="row">
                        <!-- Other Requirements  -->
                        <div class="col">
                          <div class="form-group" style="background: white;padding:5px">
                            <label for="description">Other Requirement</label>
                            <p>{{ contract?.otherSystemRequirements  }}</p>
                          </div>
                        </div>
                  </div>
              </div>

         
            <hr>
            <div *ngIf="showthedoc">
                <nz-space>
                   
                    <button *nzSpaceItem nz-button nzType="primary" (click)="showDocument()">View document</button>
                  </nz-space>
            </div>
         <br>
         
  
           <br>
            <hr>
                            <!-- Approvals -->
   <div class="card-body" >
    <h5 class="card-title">Approvals</h5>
    <div class="table-responsive" >
      <table class="table table--striped table-hover">
        <thead>
          <tr>

            <th>
              Approved By
            </th>
            <th>
              Date Approved
            </th>
            <th>
              Message
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let approval of RequestApprovals">

            <td>{{approval.approvedBy}}</td>
            <td>{{approval.dateOfApproval | date: 'dd MMMM yyyy hh:mm a'}}</td>
            <td>{{approval.message}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!RequestApprovals?.length"
      style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
      <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
    </div>
    <!-- Approvals -->
  </div>
           
          
  
  
            <hr>

            
      <div class="row">
        <!-- Comment  -->
        <div class="col">
           <div class="form-group">
             <label for="exampleTextarea1">Comment</label>
             <textarea class="form-control" id="Comment" rows="4" name="Comment" [(ngModel)]="Comment"
               required #EComment="ngModel" ></textarea>
       
            
           </div>
         </div>
       
             </div>
            <div >
                <div style="float: right" class="d-print-none">
                
                  <a   nz-popconfirm
                  nzPopconfirmTitle="Are you sure?"
                  nzOkText="ok"
                  nzCancelText="cancel"
                  (nzOnConfirm)="approveContract()"
                  (nzOnCancel)="cancelReturn()"
                  > 
                    <span style="margin-right: 8px;" class="btn btn-primary">
                        Approve
                    </span>
                </a> 
                
                <a   nz-popconfirm
                nzPopconfirmTitle="Are you sure?"
                nzOkText="ok"
                nzCancelText="cancel"
                (nzOnConfirm)="rejectContract()"
                (nzOnCancel)="cancelReturn()"
                > 
                  <span style="margin-right: 8px;"class="btn btn-danger">
                      Reject
                  </span>
              </a> 
                  
                  
               
                </div>
           
           
              </div>
             
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>


  
  <div class="content-wrapper" *ngIf="hasUserApprovedContract">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title"> </h4>
         
  
            <div  style="text-align: center; padding: 18px;">
              <h4 style="color: rgba(128, 128, 128, 0.741); ">This request has been approved</h4>
            </div>

                          <!-- Approvals -->
<div class="card-body" >
<h5 class="card-title">Approvals</h5>
<div class="table-responsive" >
  <table class="table table--striped table-hover">
    <thead>
      <tr>

        <th>
          Approved By
        </th>
        <th>
          Date Approved
        </th>
        <th>
          Message
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let approval of RequestApprovals">

        <td>{{approval.approvedBy}}</td>
        <td>{{approval.dateOfApproval | date: 'dd MMMM yyyy hh:mm a'}}</td>
        <td>{{approval.message}}</td>
      </tr>
    </tbody>
  </table>
</div>
<div  style="text-align: center; padding: 18px;">
    <button class="btn btn-primary" style="margin-right: 8px;"  (click)="cancel()">Close</button>
  </div>


<div *ngIf="!RequestApprovals?.length"
  style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
  <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
</div>
<!-- Approvals -->
</div>
     
          </div>
        </div>
      </div>
  
  
    </div>
  </div>
